<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="werke">
            <h2>
                Proben Stammdaten
                <b-button :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt Proben Stammdaten..."
                emptyText="Keine Proben Stammdaten gefunden"
            >
                <template v-slot:ablaufdatum="{row: row}">{{$moment(row.value).format("DD.MM.Y")}}</template>
                <template v-slot:pflicht="{row: row}">{{row.value + '%'}}</template>

                <template v-slot:actions="{row: row}">
                    <b-button
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                    >Bearbeiten</b-button>
                    <b-button
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button>
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                id="newModal"
                buttonText="Anlegen"
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder :fields="ioFields" :data="selected.data" />
                </template>
            </EditModal>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                size="xl"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <b-tabs pills card vertical>
                    <b-tab title="Probeninformationen" active>
                        <template v-if="selected.data">
                            <FormGroupBuilder :fields="ioFields" :data="selected.data" />
                        </template>
                    </b-tab>
                    <b-tab title="Einzelproben">
                        <template v-if="selected.data">
                            <Einzelproben
                                :probe="selected.data"
                                :probenstamm="items"
                                @update="updateEinzelproben"
                            />
                        </template>
                    </b-tab>
                </b-tabs>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Einzelproben from "@/components/Einzelproben/Einzelproben";

const ProbenStammdatenApi = ApiFactory.get("proben_stammdaten");
const WerkeApi = ApiFactory.get("werke");

export default {
    name: "ProbenStammdaten",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder,
        Einzelproben
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "werk",
                    label: "Probenbezeichnung",
                    sortable: true
                },
                {
                    key: "ablaufdatum",
                    label: "Datum",
                    sortable: true
                },
                {
                    key: "werk_name",
                    label: "Werk",
                    sortable: true
                },
                {
                    key: "pflicht",
                    label: "Pflichtproben",
                    class: "text-right"
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: [
                {
                    key: "id",
                    label: "ID",
                    type: "text",
                    disabled: true,
                    oneWay: true
                },
                {
                    key: "werk",
                    label: "Probenbezeichnung",
                    type: "text",
                    placeholder: "",
                    description: ""
                },
                {
                    key: "ablaufdatum",
                    label: "Datum",
                    type: "date"
                },
                {
                    key: "besetzung_werke_id",
                    label: "Zurodnung Werk",
                    placeholder: "",
                    type: "select",
                    options: []
                },
                {
                    key: "pflicht",
                    label: "Pflichtproben",
                    type: "text"
                },
                {
                    key: "konzert",
                    label: "ist Konzert?",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description: ""
                },
                {
                    key: "visible",
                    label: "in Proben-Soll sichtbar?",
                    type: "checkbox",
                    disabled: true,
                    checked_value: 1,
                    unchecked_value: 0,
                    description: ""
                },
                {
                    key: "stimmen",
                    label: "zugeordnete Stimmen",
                    type: "checkboxgroup",
                    options: [
                        {
                            value: "sopran",
                            text: "Sopran"
                        },
                        {
                            value: "alt",
                            text: "Alt"
                        },
                        {
                            value: "tenor",
                            text: "Tenor"
                        },
                        {
                            value: "bass",
                            text: "Bass"
                        }
                    ]
                }
            ],
            api: ProbenStammdatenApi,
            werke: {
                busy: false,
                items: [],
                options: []
            },
            einzelproben: []
        };
    },
    created() {
        this.fetchWerke();
    },
    watch: {},
    methods: {
        async fetchWerke() {
            this.werke.busy = true;
            const response = await WerkeApi.get();
            if (response.ok) {
                const data = response.json.collection;
                this.werke.items = data;
                var options = data.map(item => {
                    return {
                        value: item.id,
                        text:
                            item.bezeichnung +
                            " - " +
                            this.$moment(item.verfallsdatum)
                                .subtract("1", "day")
                                .format("DD.MM.Y")
                    };
                });
                this.werke.options = options;
                const ioFieldIndex = this.ioFields.findIndex(
                    item => item.key === "besetzung_werke_id"
                );
                this.ioFields[ioFieldIndex].options = options;
            }
            this.werke.busy = false;
        },
        process(item) {
            var stimmen = [];
            if (item.sopran === 1) {
                stimmen.push("sopran");
            }
            if (item.alt === 1) {
                stimmen.push("alt");
            }
            if (item.tenor === 1) {
                stimmen.push("tenor");
            }
            if (item.bass === 1) {
                stimmen.push("bass");
            }
            item.stimmen = stimmen;
            return item;
        },
        dataCreate() {
            const newObj = {};
            this.dataSet(newObj, "new", "Neu erstellen");
            this.$root.$emit("bv::show::modal", "newModal");
        },
        updateEinzelproben(val) {
            this.einzelproben = val;
        },
        async additionalRequests(selectedItem) {
            const response = await ProbenStammdatenApi.putEinzelprobe(
                selectedItem.id,
                this.einzelproben
            );
            return response.ok;
        }
    }
};
</script>
